import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import TitlePage from '../components/TitlePage';
import ContactInfo from '../components/ContactInfo';
import ContactForm from '../components/ContactForm';
import headerImage from '../assets/images/about/12.jpg';

const Contact = () => {
  const airMetrologieInfo = {
    title: "Contactez AIR METROLOGIE",
    siegeAddress: "Bd Chefchaouni KM 8.5 Porte B,1 er Etage Appt 3 Aîn Sebâa -Casablanca",
    laboCasaAddress: "N°12 Lotissement MAURITANIA Q.I SIDI BERNOUSSI - Casablanca MAROC",
    laboTangerAddress: "TFZ LT 38C,ET1,BU20 90000 - Tanger",
    phones: [
      "+212 5 22 35 06 43",
      "+212 5 22 35 11 93",
      "+212 5 22 35 02 65",
      "+212 6 61 98 32 35"
    ],
    email: "a.metrologie@gmail.com",
    linkedin: "#",
    instagram: "#"
  };

  const l2miInfo = {
    title: "Contactez L2MI",
    siegeAddress: "Casablanca lot N° 18 Quartier Industriel Mauritania 4ème étage, Sidi Bernoussi-Maroc",
    laboCasaAddress: "N° 12 & 14 Lot Mauritania, QI. Sidi Bernoussi - Casablanca - Maroc",
    laboTangerAddress: "TFZ LT 38C,ET1,BU20 90000 - Tanger",
    phones: [
      "+212 673 868 680",
      "+212 522 344 541",
      "+212 661 073 361"
    ],
    email: "l2mi2008@gmail.com",
    linkedin: "#",
    instagram: "#"
  };

  return (
    <Box>
      <TitlePage 
        title="Contactez-nous" 
        image={headerImage}
      />

      <Container maxWidth="xl" sx={{ py: { xs: 6, md: 10 }, px: { xs: 2, sm: 4, md: 8, lg: 12 } }}>
        <Grid container spacing={4} sx={{ mb: 12 }}>
          <Grid item xs={12} md={6}>
            <ContactInfo {...airMetrologieInfo} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ContactInfo {...l2miInfo} />
          </Grid>
        </Grid>

        <ContactForm />
      </Container>
    </Box>
  );
};

export default Contact;
